import type { ReactNode } from "react";
import RequireRole from "@/components/RequireRole";

/**
 * 共有お問い合わせ画面のUXガード。
 * 認可の正はbackendのrequireInternalSupportで維持する。
 */
export default function RequireSupportInbox({ children }: { children: ReactNode }) {
  return (
    <RequireRole
      allow={(role) => role.isPlatformAdmin || role.role === "internal_support"}
      fallback="redirect"
    >
      {children}
    </RequireRole>
  );
}
